import { PraticaType } from '../../interfaces/pratica';
import { PraticaSection } from '../pratica/models/pratica-section';
import { Slice } from './models/slice';

export const getPraticaFlowSlices = (praticaType: PraticaType): Slice[] => {
  const PRATICA_FLOW_SLICES: Slice[] = [
    {
      sectionPath: PraticaSection.REQUESTS,
      disabled: false,
      tooltipPosition: 'above',
      tooltip: 'Richieste',
      ariaLabel: 'Richieste',
      icon: 'applicant',
    },
    {
      sectionPath: PraticaSection.SCORE,
      disabled: false,
      tooltipPosition: 'after',
      tooltip: 'Score',
      ariaLabel: 'Punteggio',
      icon: 'score',
    },
    {
      sectionPath: PraticaSection.PRESENTATION_SHEET,
      disabled: false,
      tooltipPosition: 'above',
      tooltip: 'Scheda di presentazione',
      ariaLabel: 'Scheda di presentazione',
      icon: 'presentation-sheet',
    },
    {
      sectionPath: PraticaSection.DOCUMENTS,
      disabled: false,
      tooltipPosition: 'above',
      tooltip: 'Documenti',
      ariaLabel: 'Documenti',
      icon: 'documents',
    },
    {
      sectionPath: PraticaSection.APPLICANT,
      disabled: false,
      tooltipPosition: 'after',
      tooltip: praticaType === 'FIN' ? 'Richiedente' : 'Cliente',
      ariaLabel: praticaType === 'FIN' ? 'Richiedente' : 'Cliente',
      icon: 'requests',
    },
    {
      sectionPath: PraticaSection.ANAGRAPHICS,
      disabled: false,
      tooltipPosition: 'above',
      tooltip: 'Anagrafiche',
      ariaLabel: 'Anagrafiche',
      icon: 'anagraphics',
    },
  ];
  return PRATICA_FLOW_SLICES;
};
